import type { OrbitSlice } from './Common/Orbit/orbitTypes'
import { datasetId, slice, targetlessSlice, type OrbitActionBridge } from './Common/Orbit/orbitSliceHelpers'
import {
  CompleteIcon,
  DeleteIcon,
  DuplicateIcon,
  EditIcon,
  LinkIcon,
  MoveToIcon,
  NewGoalIcon,
  NewTaskIcon,
  RealignIcon,
  RenameIcon,
  ReprioritizeIcon,
  ShiftIcon,
  ShowConnectionsIcon,
  ShowDependenciesIcon,
} from './Common/Orbit/icons'

export type DashboardOrbitAction = OrbitActionBridge
const idOf = (node: HTMLElement) => datasetId(node, 'goalId', 'taskId', 'markerId')

export const buildGoalRowSlices = (node: HTMLElement, action: DashboardOrbitAction): OrbitSlice[] => [
  slice('goal-rename', 'Rename', RenameIcon, action, node, idOf),
  slice('goal-reprioritize', 'Reprioritize', ReprioritizeIcon, action, node, idOf),
  slice('goal-link', 'Link', LinkIcon, action, node, idOf),
  slice('goal-delete', 'Delete', DeleteIcon, action, node, idOf),
  slice('goal-connections', 'Show connections', ShowConnectionsIcon, action, node, idOf, true), // TODO(orbit-phase-6): wire real handler
]

export const buildTaskCardSlices = (node: HTMLElement, action: DashboardOrbitAction): OrbitSlice[] => [
  slice('task-complete', 'Complete', CompleteIcon, action, node, idOf),
  slice('task-duplicate', 'Duplicate', DuplicateIcon, action, node, idOf),
  slice('task-move', 'Move to…', MoveToIcon, action, node, idOf),
  slice('task-link', 'Link', LinkIcon, action, node, idOf),
  slice('task-delete', 'Delete', DeleteIcon, action, node, idOf),
]

export const buildMarkerSlices = (node: HTMLElement, action: DashboardOrbitAction): OrbitSlice[] => [
  slice('marker-edit', 'Edit', EditIcon, action, node, idOf),
  slice('marker-shift', 'Shift', ShiftIcon, action, node, idOf),
  slice('marker-dependencies', 'Show dependencies', ShowDependenciesIcon, action, node, idOf, true), // TODO(orbit-phase-6): wire real handler
  slice('marker-delete', 'Delete', DeleteIcon, action, node, idOf),
]

export const buildDashboardCanvasSlices = (action: DashboardOrbitAction): OrbitSlice[] => [
  targetlessSlice('canvas-new-goal', 'New goal', NewGoalIcon, action),
  targetlessSlice('canvas-new-task', 'New task', NewTaskIcon, action),
  targetlessSlice('canvas-realign', 'Realign', RealignIcon, action),
  targetlessSlice('canvas-connections', 'Show all connections', ShowConnectionsIcon, action, true), // TODO(orbit-phase-6): wire real handler
]
